/**
 * Website Settings Utility
 * Fetches website-specific settings from API
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const isLocal = typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/i.test(window.location?.hostname || '');
const WEBSITE_DOMAIN = process.env.REACT_APP_WEBSITE_DOMAIN || (isLocal ? 'bookyatri.com' : (typeof window !== 'undefined' ? window.location.hostname : 'bookyatri.com'));

/**
 * Get website settings from API
 * @returns {Promise<Object>} Website settings object
 */
export const getWebsiteSettings = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/settings/website/${WEBSITE_DOMAIN}`);
    if (response.ok) {
      const data = await response.json();
      if (data.success && data.data) {
        return data.data;
      }
    }
    return null;
  } catch (error) {
    console.error('Error fetching website settings:', error);
    return null;
  }
};

/**
 * Get website type from environment or domain
 * @returns {string} Website type (user, admin, partner, agent, corporate)
 */
export const getWebsiteType = () => {
  return process.env.REACT_APP_WEBSITE_TYPE || 
         (WEBSITE_DOMAIN.includes('admin') ? 'admin' :
          WEBSITE_DOMAIN.includes('partner') ? 'partner' :
          WEBSITE_DOMAIN.includes('agent') ? 'agent' :
          WEBSITE_DOMAIN.includes('corporate') ? 'corporate' : 'user');
};

/**
 * Get website name from environment
 * @returns {string} Website name
 */
export const getWebsiteName = () => {
  return process.env.REACT_APP_WEBSITE_NAME || 'BookYatri';
};
